import {
  FeatureFlagEnum,
  WorkflowDefinitionTriggerTypeEnum,
} from 'src/api/ProactApiClient';
import {TriggerScheduleEditor} from './TriggerScheduleEditor';
import {TriggerFormSubmissionEditor} from './TriggerFormSubmissionEditor';
import {TriggerTaskCompletionEditor} from './TriggerTaskCompletionEditor';
import {TriggerTrainingEditor} from './TriggerTrainingEditor';
import {TriggerItemTrackerEditor} from './TriggerItemTrackerEditor';
import type {TriggerEditorProps} from './TriggerCard';

export interface TriggerTypeConfig {
  type: WorkflowDefinitionTriggerTypeEnum;
  label: string;
  description: string;
  featureFlag?: FeatureFlagEnum;
  editor: React.FC<TriggerEditorProps>;
}

export const triggerTypeConfigs: TriggerTypeConfig[] = [
  {
    type: WorkflowDefinitionTriggerTypeEnum.Schedule,
    label: 'Schedule',
    description:
      'Run on a recurring schedule — daily, weekly, monthly, or at a custom interval.',
    editor: TriggerScheduleEditor,
  },
  {
    type: WorkflowDefinitionTriggerTypeEnum.FormSubmission,
    label: 'Form Submission',
    description: 'Trigger when a specific form is submitted.',
    featureFlag: FeatureFlagEnum.Forms,
    editor: TriggerFormSubmissionEditor,
  },
  {
    type: WorkflowDefinitionTriggerTypeEnum.TaskCompletion,
    label: 'Task Completion',
    description: 'Trigger when a specific task is completed.',
    editor: TriggerTaskCompletionEditor,
  },
  {
    type: WorkflowDefinitionTriggerTypeEnum.Training,
    label: 'Training',
    description:
      'Trigger when a training course creates a completed or failed event.',
    featureFlag: FeatureFlagEnum.Training,
    editor: TriggerTrainingEditor,
  },
  {
    type: WorkflowDefinitionTriggerTypeEnum.ItemTracker,
    label: 'Item Tracker',
    description:
      'Trigger when an item assignment changes state (e.g., assigned, returned).',
    featureFlag: FeatureFlagEnum.ItemTracker,
    editor: TriggerItemTrackerEditor,
  },
];

export const getTriggerConfig = (
  type: WorkflowDefinitionTriggerTypeEnum
): TriggerTypeConfig | undefined =>
  triggerTypeConfigs.find(c => c.type === type);
